import { useQueries } from "@tanstack/react-query";
import { getDataQuery } from "api";
import { IsPass } from "components/common";
import OnlineAttendancePopup from "components/popup/OnlineAttendancePopup";
import BreadCrumb from "components/shared/BreadCrumb";
import { Sidebar } from "components/shared/sidebar";
import { useState } from "react";
import { Table } from "react-bootstrap";
import { useRecoilValue } from "recoil";
import { loginUser } from "recoil/loginUser";
import { subjectOptionDataState } from "recoil/subject/subjectOptionDataState";

export const Score = ({ setVisibleGrade, student }) => {
  const user = useRecoilValue(loginUser);
  const subjectState = useRecoilValue(subjectOptionDataState);
  const [visiblePopup, setVisiblePopup] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState({ userNumber: '', userName: '', totalScore: '', finalGrade: '' });
  const studentSubjectApis = useQueries({
    queries: [
      {
        // 학생 - [성적현황] 과목의 성적 현황 조회
        queryKey: ['studentGradeList', user, subjectState],
        queryFn: () => getDataQuery(`/course/${subjectState.courseId}/student/grade?studentId=${user.loginId}`),
        enabled: !!subjectState.courseId,
      },
    ],
  });

  const [
    studentGradeList,
  ] = studentSubjectApis?.map((query) => query?.data?.data || []);
  console.log("studentGradeList: ", studentGradeList);


  const handleNameClick = (userNumber, userName, totalScore, finalGrade) => {
    setSelectedStudent({ userNumber, userName, totalScore, finalGrade }); // 상태 추가
    setVisiblePopup(true);
  };

  return (
    <>
      <Sidebar />
      <main id='main' className='main'>
        <BreadCrumb home={'/'} sublink={'/grade'} title={'성적 (Grade)'} subTitle={'성적현황'} />
        <div className='card p-20'>
          <div className="d-flex justify-content-start align-items-center mb-3" style={{ gap: '1rem' }}>
            <div className="d-flex align-items-center" style={{ fontSize: '16px' }}>
              <span className="fw-bold me-2">{subjectState.termName}</span>
              <span className="text-muted mx-2">|</span>
              <span className="fw-bold">{subjectState.courseName}</span>
            </div>
          </div>
        {studentGradeList ? (
          <>
            <div className="table-container" style={{ position: 'relative' }}>
              {/* 테이블 */}
              <div style={{ overflowX: 'auto' }}>
                <Table>
                  {/* 헤더 */}
                  <thead className="border border-start-0 border-end-0">
                    <tr>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border border-start-0 border-end-0"
                        style={{ background: '#EBF1FA',
                                 minWidth: '100px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center' }}
                      >
                        <div className="d-flex justify-content-center align-items-center">번호</div>
                      </td>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border border-start-0"
                        style={{ minWidth: '130px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center'
                         }}
                      >
                        <div className="d-flex justify-content-center align-items-center">이름</div>
                      </td>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border border-start-0 border-end-0"
                        style={{ minWidth: '130px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center'
                         }}
                      >
                        <div className="d-flex justify-content-center align-items-center">학번</div>
                      </td>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border"
                        style={{ minWidth: '120px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center'
                         }}
                      >
                        <div className="d-flex justify-content-center align-items-center">총 점수</div>
                      </td>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border"
                        style={{ minWidth: '120px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center'
                         }}
                      >
                        <div className="d-flex justify-content-center align-items-center">출석 현황</div>
                      </td>
                      <td
                        rowSpan={3}
                        className="align-middle CHA_LIGHT border"
                        style={{ minWidth: '120px',
                                 whiteSpace: 'nowrap',
                                 textAlign: 'center'
                         }}
                      >
                        <div className="d-flex justify-content-center align-items-center">최종 등급 (P/N)</div>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {studentGradeList?.map((student, index) => (
                      <tr key={index}>
                        {/* 기본 정보 */}
                        <td
                          className="border border-start-0 border-end-0"
                          style={{ background: '#EBF1FA' }}
                        >
                          <div className="d-flex justify-content-center">{index + 1}</div>
                        </td>
                        <td className="border border-start-0">
                          <div
                            className="d-flex justify-content-center Blue-500 cursor-pointer"
                            onClick={() => handleNameClick(student.userNumber, student.userName, student.totalScore, student.totalGrade)}
                          >
                            {student.userName}
                          </div>
                        </td>
                        <td className="border border-start-0 border-end-0">
                          <div className="d-flex justify-content-center">{student.userNumber}</div>
                        </td>
                        <td className="border">
                          <div className="d-flex justify-content-center">{student.totalScore} / 100</div>
                        </td>
                        <td className="border">
                          <div className="d-flex justify-content-center">{student.attendanceCount} / {student.totalAttendanceCount}</div>
                        </td>
                        <td className="border">
                          <div className="d-flex justify-content-center"><IsPass completed={student.totalGrade} /></div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
          ) : (
            ""
          )}
        </div>
      </main>
        {visiblePopup && (
          <OnlineAttendancePopup
            setVisiblePopup={setVisiblePopup}
            userNumber={selectedStudent.userNumber}
            userName={selectedStudent.userName}
            courseId={subjectState.courseId}
            type={'grade'}
            totalScore={selectedStudent.totalScore}
            finalGrade={selectedStudent.finalGrade}
          />
        )}
      </>
  );
};
